import { DOCUMENT } from '@angular/common';
import { DestroyRef, inject, Inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WindowRef } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user';
import { fromEvent, Observable } from 'rxjs';
import { debounceTime, filter, map, startWith, take } from 'rxjs/operators';
import { AnalyticsService } from './analytics.service';

@Injectable({ providedIn: 'root' })
export class UserSessionAnalyticsService {
  private readonly ttl = 30 * 60 * 1000;
  private readonly storageKey = 'last_visit_time';
  private analyticsService = inject(AnalyticsService);

  constructor(
    private userAccountService: UserAccountFacade,
    private destroyRef: DestroyRef,
    private winRef: WindowRef,
    @Inject(DOCUMENT) private document: any,
  ) {}

  sendUserParams(): void {
    this.userAccountService
      .get()
      .pipe(filter(Boolean), take(1))
      .subscribe(({ rosaUuid }) => {
        if (rosaUuid) {
          this.analyticsService.sendEvent({
            event: 'userlogin',
            loyalty_id: rosaUuid,
          });
        }

        this.updateSession();
      });
  }

  init(): void {
    if (!this.checkActiveSession()) {
      this.sendUserParams();
    }

    this.onUserInteracts()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        if (!this.checkActiveSession) {
          this.sendUserParams();
        }
      });
  }

  private updateSession(): void {
    this.winRef.localStorage?.setItem(this.storageKey, Date.now().toString());
  }

  private checkActiveSession(): boolean {
    const lastVisitTime = Number(this.winRef.localStorage?.getItem(this.storageKey));

    if (!lastVisitTime || Number(lastVisitTime) === 0) {
      return false;
    }

    return Date.now() - Number(lastVisitTime) <= this.ttl;
  }

  /**
   * Эмитит событие каждый раз когда пользователь взаимодействует с сайтом
   * Под активностью подразумевается клик в любом месте сайта
   */
  private onUserInteracts(): Observable<void> {
    return fromEvent(this.document, 'click').pipe(
      debounceTime(1000),
      startWith(true),
      map(() => undefined),
    );
  }
}
